import useSelector from '@app/hooks/useSelector'
import { getFeatureState } from '@app/selectors'

export type Feature =
  | 'homeFeatureLqai'
  | 'lionLfcFilesManagement'
  | 'lionFeatureFilesManagementBulkActions'
  | 'trexFeatureAutomaticTranslations'
  | 'metroFeatureMachineTranslationTasks'
  | 'perfFeatureReportingEngine'
  | 'homeFeatureAiLqaSuggestions'
  | 'homeFeatureAibilling'
  | 'growthFeatureAiUpsellPathway'
  | 'homeFeatureAutomaticTranslationUse100TMMatch'
  | 'homeFeatureAutomaticTranslationUseFuzzyMatch'
  | 'growthSubscriptionExtras'
  | 'growthCancellationFlow'
  | 'growthPricingV2'
  | 'growthPricingBundlesV2'
  | 'growthPricingV2WipUsageOverview'
  | 'growthFeatureGrowthPlanSwitchFlow'
  | 'growthFeatureVantageDiscoverability'
  | 'metroCustomWorkflows'
  | 'metroFeatureWorkflowsAiScoring'
  | 'maxMigrationForm'
  | 'gitLabRecursivePullEnabled'
  | 'perfFeatureAsyncExport'
  | 'exportAppleStringsReplaceU2028Disabled'
  | 'translationsScoringDisabled'
  | 'translationsFeatureProfileEval'
  | 'experimentEmberAiAssistant'
  | 'ayayAiAssistantEmber'
  | 'experimentGenerateStyleGuide'
  | 'apFeaturePortal'
  | 'cexScheduleDitto'
  | 'cexScheduleStoryblok'
  | 'cexScheduleIterable'
  | 'cexScheduleContentfulNative'
  | 'cexScheduleBraze'
  | 'ayayAnalyticsBanners'
  | 'growthFeatureDitchFreePlan'
  | 'metroFeatureTasksExcludeGroupMembers'
  | 'metroFeatureWorkflowsPostTmStatus'
  | 'metroFeatureWorkflowsMinutelyTrigger'
  | 'perfFeatureRealtimeNotifications'
  | 'trapFeatureScoringTaskOptions'
  | 'cexImportApi'
  | 'expFeatureGlossaryHighlight'

export const useFeatureState = (feature: Feature): string | boolean | undefined => {
  const featureState = useSelector((state) => getFeatureState(state.features, feature))

  return featureState !== null ? featureState : undefined
}
